module.exports = __webpack_public_path__ + "img/empty.923470a9.svg";